
/**
 * UpdatePatrimonioChecklistMaquinaEquipUseCase
 */

import { IUpdatePatrimonioChecklistMaquinaEquipUseCase } from "../../../presentation/useCases/update/update_patrimonio_checklist_maquina_equip_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

export class UpdatePatrimonioChecklistMaquinaEquipUseCase implements IUpdatePatrimonioChecklistMaquinaEquipUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async updatePatrimonioChecklistMaquinaEquip(
    idPatrimonioChecklistMaquinaEquip: number,
    idPatrimonioCentroCusto: number | null,
    idChecklistMaquinaEquip: number | null,
    idPatrimonioMaquinaEquip: number | null,
    metaAprovacao: number | null,
    status: number | null,
  ): Promise<void> {
    await this.repository.updatePatrimonioChecklistMaquinaEquip(
      idPatrimonioChecklistMaquinaEquip,
      idPatrimonioCentroCusto,
      idChecklistMaquinaEquip,
      idPatrimonioMaquinaEquip,
      metaAprovacao,
      status,
    );
  }
}
